import { useEffect } from 'react';

/**
 * Escapeキーが押されたときにコールバックを実行するカスタムフック
 * @param {Function} callback - Escapeキーが押されたときに実行する関数
 * @param {boolean} isActive - フックが有効かどうか
 */
export const useEscapeKey = (callback, isActive = true) => {
  useEffect(() => {
    if (!isActive) return;

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        callback();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [callback, isActive]);
};
